import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, message,Popconfirm } from "antd";
import { ContentTopBar } from "components";
import { getSuffixUserId } from "features/auth";
import { EventsFilterFormValues } from "features/events/components/events-filter-form";
import { useAddStratgeic } from "features/events/use-cases/addupdatestrategicpartner";
import { useGetSponser } from "features/events/use-cases/get-sponser";
import { strategicpartnertitle } from "features/events/use-cases/strategicpartnertitle";
import { usePermissions } from "features/users";
import { usePaginationParams } from "hooks";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AddSponserModal from "./add-sponser-modal/add-sponser-modal";
import AddStrategicPartnerModal from "./add-strategic-modal/AddStrategicPartnerForm";
import { SponserTable } from "./sponser-table";

const EventSponser = ({ tabs }: { tabs: string }) => {
  const { id } = useParams();
  const permissions = usePermissions();
  const suffixUserId = getSuffixUserId();
  const [showAddSponserModal, setShowAddSponserModal] = useState(false);
  const [sponserData, setSponserData] = useState<any>();

  const [showStrategicModal, setShowStrategicModal] = useState(false);
  const [strategicPartner, setStrategicPartner] = useState<any>(null);
  const [selectedStrategicPartner, setSelectedStrategicPartner] =
    useState<any>(null);

  const { mutateAsync: addUpdateStrategic, isLoading } =
    useAddStratgeic(id);

  const initialFilterValues: EventsFilterFormValues = {
    field_name: undefined,
  };

  const { params, updateParams } = usePaginationParams<any>({
    user_id: suffixUserId,
    event_id: id,
    order_by: "-rank",
    size: 10,
    page: 1,
    ...initialFilterValues,
  });

  const { data, isFetching, refetch } = useGetSponser(params);

  const shouldHandleFieldCreation = permissions?.fields.add;

  // ✅ LOAD STRATEGIC PARTNER
  const loadStrategicPartner = async () => {
    if (!id) return;
    const res = await strategicpartnertitle(id);
    setStrategicPartner(res || null);
  };

  useEffect(() => {
    loadStrategicPartner();
  }, [id]);

  // ✅ FIXED DELETE HANDLER
  const handleDeleteStrategicPartner = async () => {
    if (!id) return;

    try {
      // ✅ immediately reset UI
      setStrategicPartner(null);
      setSelectedStrategicPartner(null);

      await addUpdateStrategic({
        LoginUserId: 1,
        EventId: Number(id),
        Title: null,
        TitleAr: null,
        isDelete: true,
      });

      // small delay to avoid stale data
      await new Promise((res) => setTimeout(res, 300));

      await loadStrategicPartner();
    } catch (error) {
      console.error("Delete failed", error);
      message.error("Failed to delete");
    }
  };

  useEffect(() => {
    if (tabs === "2") {
      refetch();
    }
  }, [tabs]);

  const handleOpenSponser = () => {
    setShowAddSponserModal(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseSponser = () => {
    setShowAddSponserModal(false);
    document.body.style.overflow = "visible";
  };

  // ✅ FIXED OPEN HANDLER
  const handleOpenStrategicPartner = () => {
    if (strategicPartner?.Title) {
      setSelectedStrategicPartner(strategicPartner); // edit
    } else {
      setSelectedStrategicPartner(null); // add
    }

    setShowStrategicModal(true);
    document.body.style.overflow = "hidden";
  };

  const handleCloseStrategicPartner = () => {
    setShowStrategicModal(false);
    setSelectedStrategicPartner(null);
    document.body.style.overflow = "visible";
  };

  const englishName = strategicPartner?.Title?.trim();
  const arabicName = strategicPartner?.TitleAr?.trim();

  const displayName = [englishName, arabicName]
    .filter(Boolean)
    .join(" / ");

  // ✅ FIXED CONDITION (IMPORTANT)
  const hasStrategicPartner = !!strategicPartner?.Title;

  return (
    <div className="sponse_Pge">
      <ContentTopBar
        title={""}
        renderButtons={
          <div className="spn-txt">
            {shouldHandleFieldCreation && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", gap: "10px" }}>
                  {/* STRATEGIC BUTTON */}
                  <Button
                    onClick={handleOpenStrategicPartner}
                    className="spnser_btn"
                  >
                    {hasStrategicPartner ? (
                      <>
                        <EditOutlined />
                        <span
                          style={{
                            marginLeft: "10px",
                            maxWidth: 190,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {displayName}
                        </span>
                      </>
                    ) : (
                      <>
                        <PlusOutlined />
                        <span style={{ marginLeft: "10px" }}>
                          Add Strategic Partner Name
                        </span>
                      </>
                    )}
                  </Button>

                  {/* DELETE BUTTON */}
                  {hasStrategicPartner && (
                    <Popconfirm
                      title="Delete Strategic Partner"
                      description="Are you sure you want to delete this?"
                      onConfirm={handleDeleteStrategicPartner}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button
                        danger
                        icon={<DeleteOutlined />}
                        loading={isLoading}
                      />
                    </Popconfirm>
                  )}
                </div>

                {/* RIGHT SIDE */}
                <Button
                  onClick={handleOpenSponser}
                  style={{
                    border: "2px solid #000",
                    fontWeight: 500,
                  }}
                >
                  Add Sponsor
                </Button>
              </div>
            )}

            {/* SPONSER MODAL */}
            <div className={`cstmrightmdl ${showAddSponserModal && "show"}`}>
              <AddSponserModal
                onClose={handleCloseSponser}
                refetch={refetch}
                sponserData={sponserData}
              />
            </div>
          </div>
        }
      />

      {/* ✅ FIXED MODAL */}
      {showStrategicModal && (
        <AddStrategicPartnerModal
          mode={selectedStrategicPartner ? "edit" : "add"} // ✅ FIX
          strategicPartnerData={selectedStrategicPartner}
          onClose={handleCloseStrategicPartner}
          refetch={async () => {
            await loadStrategicPartner();
          }}
        />
      )}

      {/* TABLE */}
      <SponserTable
        data={data}
        isLoading={isFetching}
        tableParams={params}
        updateParams={updateParams}
        refetch={refetch}
        sponserData={sponserData}
        setSponserData={setSponserData}
      />
    </div>
  );
};

export default EventSponser;